import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom, map } from 'rxjs/operators';

import * as fromStore from '../store';
import * as fromRoot from '../../store';
import { Observable, of } from 'rxjs';
import { SetTheme } from '../../store';

@Injectable({ providedIn: 'root' })
export class DiseaseProfilesEmptyGuard  {
  private store = inject<Store<fromStore.DiseaseProfileState>>(Store);


  canDeactivate() {
    return this.store.select(fromStore.getDiseaseProfilesLoaded).pipe(
      tap(loaded => {
        if (loaded) {
          this.store.dispatch(fromStore.ClearDiseaseProfiles());
        }
      }),
      filter(loaded => !loaded),
      map(loaded => !loaded),
      take(1)
    );
  }
}
